import { render, staticRenderFns } from "./UnitLargeCode.vue?vue&type=template&id=20500e63&scoped=true"
import script from "./UnitLargeCode.vue?vue&type=script&lang=js"
export * from "./UnitLargeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20500e63",
  null
  
)

export default component.exports